import angular = require("angular");
import TPL = require("templates");

export class HostDirective {

  template = TPL.contentDirectives.host;
  scope = {
    params: "=params"
  };

  static factory() {
    return () => new HostDirective();
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/host.ts
 **/